export const DYNAMIC_FORM_JSON_SPINNER_TEST_ID = 'dynamic-form-json-spinner';
export const DYNAMIC_FORM_JSON_BACK_BTN_TEST_ID = 'dynamic-form-json-back-btn';
export const DYNAMIC_FORM_JSON_SAVE_BTN_TEST_ID = 'dynamic-form-json-save-btn';
